import PropTypes from 'prop-types';

export const SELECT_ALL_LABEL = 'Select All';
export const SELECT_ALL_ID = -1;

export const ActionTypeEnum = {
  CLEAR: 'clear',
  CREATE_OPTION: 'create-option',
  DESELECT_OPTION: 'deselect-option',
  POP_VALUE: 'pop-value',
  REMOVE_VALUE: 'remove-value',
  SELECT_OPTION: 'select-option',
  SET_VALUE: 'set-value',
};

export const OptionType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.node,
  value: PropTypes.string,
});

export const OptionsType = PropTypes.arrayOf(OptionType);

// or null | void
export const ValueType = PropTypes.oneOfType([OptionType, OptionsType]);
